
export default function SyracuseNeighborhoods() {
  const neighborhoods = [
    {
      name: 'Bluff Ridge',
      description: 'Elevated neighborhood with stunning Great Salt Lake views, where we provide careful restoration addressing unique drainage and water damage challenges.',
      icon: 'ri-landscape-line'
    },
    {
      name: 'Lakeside Village',
      description: 'Waterfront community along the Great Salt Lake requiring specialized flood protection and rapid emergency response services.',
      icon: 'ri-water-flash-line'
    },
    {
      name: 'Syracuse Meadows',
      description: 'Family-friendly community near Syracuse Community Park with modern homes we proudly serve for all disaster cleanup needs.',
      icon: 'ri-community-line'
    },
    {
      name: 'Antelope Ridge',
      description: 'Scenic neighborhood with Antelope Island views, where we address unique storm and water damage challenges for local homeowners.',
      icon: 'ri-home-4-line'
    },
    {
      name: 'West Point Estates',
      description: 'Established residential area near West Point with homes and commercial properties we serve with 24/7 emergency response.',
      icon: 'ri-building-line'
    },
    {
      name: 'Syracuse Hills',
      description: 'Hillside community with panoramic valley views, where our team provides comprehensive water damage and storm restoration services.',
      icon: 'ri-map-pin-line'
    }
  ];

  return (
    <section className="py-12 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            Syracuse Neighborhoods We Serve
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            Fast water damage restoration response throughout all Syracuse areas
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {neighborhoods.map((neighborhood, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-5 md:p-8 shadow-sm hover:shadow-lg transition-all hover:-translate-y-1"
            >
              <div className="w-11 h-11 md:w-14 md:h-14 bg-sky-100 rounded-full flex items-center justify-center mb-4 md:mb-6">
                <i className={`${neighborhood.icon} text-xl md:text-2xl text-sky-600`}></i>
              </div>
              <h3 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3">{neighborhood.name}</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">{neighborhood.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
